import { Backdrop } from "@mui/material";
import {
  CircularProgressWithContent,
  CircularProgressWithContentVariant
} from "@ui/atoms/CircularProgressWithContent/CircularProgressWithContent";

export const PageLoader = (): JSX.Element => {
  return (
    <Backdrop
      sx={(theme) => ({
        backdropFilter: "blur(5px)",
        backgroundColor: theme.vars.palette.overlay.backdrop,
        zIndex: theme.zIndex.drawer + 1
      })}
      open
    >
      <CircularProgressWithContent
        variant={CircularProgressWithContentVariant.Branded}
      />
    </Backdrop>
  );
};
